import React from 'react'
import { CustomerAddress } from 'lib/types/core'
import { useDirectoryOptions } from 'lib/core/hooks'

interface Props {
  address: CustomerAddress
}

export const ShippingData: React.FC<Props> = ({ address }) => {
  const {
    city,
    countryCode,
    firstName,
    lastName,
    postalCode,
    regionCode,
    street
  } = address
  const {
    countryInfoOptions
  } = useDirectoryOptions({ countryCode })
  const countryOption = countryInfoOptions.find(infoOption => { return infoOption.value === countryCode })

  return (
    <>
      <div className='border-box'>
        <p>{firstName} {lastName}</p>
        <p>{street}</p>
        <p>{city}, {regionCode}, {postalCode}</p>
        <p>{countryOption?.label}</p>
      </div>
    </>
  )
}
